module.exports = __webpack_public_path__ + "img/new-object-order.f50a92db.png";